import type { TemplateRenderer } from '../../types';
import { expandAndGroupByMonth } from './group';
import { Page } from './Page';
import { paginate } from './paginate';
import type { PageData } from './types';

export const calendarRenderer: TemplateRenderer<PageData> = {
  Page,
  group: expandAndGroupByMonth,
  paginate,
};
